import usePayInPayId from './usePayInPayId';

export { usePayInPayId };
